module.exports = "/_next/static/images/savedForLaterDark-4034ed62fedfcc77d6a2b5a950350b9c.svg";